<template>
    <el-dialog title="已取消产品信息" :visible.sync="outCancelProductDetailDialog" width="800px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="in_product_detail_wrap">
            <div class="page_title">
                <span>已出库产品信息</span>
            </div>
            <el-table class="custom_table" :data="tableData" border ref="table" row-key="id" >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip ></el-table-column>
                <el-table-column label="出库仓库" prop="name" show-overflow-tooltip width="182px"></el-table-column>
                <el-table-column label="出库数量\产品编码" prop="name" align="right" show-overflow-tooltip width="180px">
                    <template slot-scope="{row}">
                        <div class="change_code">
                            <el-popover  placement="bottom"  popper-class="product_code_popper" title=""  width="226"  trigger="click">
                                <span class="change_code_wrap" slot="reference" >
                                   <span>编码明细</span>
                                </span>
                                <div class="product_code_wrap">
                                    <ul>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                        <li class="ellipsis">BM-20240000001212</li>
                                    </ul>
                                    <div class="code_num_wrap">
                                        共：123条
                                    </div>
                                </div>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page_title p_top_24">
                <span>已取消产品信息</span>
            </div>
            <el-table class="custom_table" :data="cancelTableData" border ref="table" row-key="id" >
                <el-table-column label="产品名称" prop="name" show-overflow-tooltip ></el-table-column>
                <el-table-column label="取消出库数量" prop="name" show-overflow-tooltip width="222px"></el-table-column>
            </el-table>

            <div class="in_product_detail_field">
                <div class="in_product_detail_field_name">取消时间</div>
                <div class="in_product_detail_field_value">
                    <div class="in_product_detail_field_text">2024-04-29 11:59:36</div>
                </div>
                <div class="in_product_detail_field_name">取消原因</div>
                <div class="in_product_detail_field_value">
                    <div class="in_product_detail_field_text">--</div>
                </div>

            </div>

        </div>
    </el-dialog>
</template>
<script>
import {  } from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "out_cancel_product_detail",
    props: {
        outCancelProductDetailDialog: {
            type: Boolean,
            default: false
        },
        outColumnId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            tableData:[{}],
            cancelTableData:[]
        }
    },
    mixins: [pagination],
    created() {
    },
    methods: {
        getTableData(){

        },
        handleDialogClose() {
            this.$emit("update:outCancelProductDetailDialog", false)
        },
    }
}
</script>
<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
</style>